// ─── Company page data ────────────────────────────────────────────────
// Ported verbatim from dane/frontend/app/etf-website/data/company.ts.

interface HeroData {
  title: string;
}

interface LetterParagraph {
  text: string;
}

interface LetterData {
  paragraphs: LetterParagraph[];
  signOff: string;
  signName: string;
}

interface ParentCompanyColumn {
  label: string;
  title: string;
  description: string;
}

interface ParentCompanyData {
  eyebrow: string;
  title: string;
  titleAccent: string;
  description: string;
  ctaLabel: string;
  ctaHref: string;
  columns: ParentCompanyColumn[];
}

// ─── Static content ───

export const COMPANY_HERO: HeroData = {
  title: "A New Breed of ETFs",
};

export const COMPANY_LETTER: LetterData = {
  paragraphs: [
    {
      text: "Corgi Funds is an SEC-registered investment adviser building innovative products designed with evolving market conditions in mind.",
    },
    {
      text: "In a world dominated by massive, slow-moving asset managers, we believe investors deserve something different: targeted, more focused strategies.",
    },
    {
      text: "Furthermore, we believe access should not be limited by size or status. Our goal is to deliver sophisticated investment strategies built for a wider audience.",
    },
    {
      text: "Always alert. Built for the future of investing.",
    },
  ],
  signOff: "Best,",
  signName: "The Corgi Funds Team",
};

export const COMPANY_PARENT: ParentCompanyData = {
  eyebrow: "Parent Company",
  title: "The ",
  titleAccent: "Corgi",
  description:
    "Corgi is building an AI financial infrastructure company. Corgi Funds is its asset management arm, focused on bringing thoughtfully designed ETFs to market.",
  ctaLabel: "Visit Corgi",
  ctaHref: "https://www.corgi.insure/",
  columns: [
    {
      label: "Corgi Funds",
      title: "Asset Management",
      description:
        "The New Breed of ETFs. Innovative Strategies Designed for Evolving Markets. Offering a Friendly Approach to Market Access.",
    },
    {
      label: "Corgi Insure",
      title: "Business Insurance at the Speed of Compute",
      description:
        "The first full-stack AI insurance carrier. Instant quotes and modular coverage for startups at every stage, from pre-seed to growth.",
    },
  ],
};
